import React from "react"
import GeneralLayout from "../layouts/GeneralLayout"
import "../styles.css"

const Home = () => {
  return (
    <GeneralLayout>
      <div style={{ color: "white" }}>
        <div className="wrapper">
          <h1 align="center">
            <p className="effect-underline">Hello World</p>
          </h1>
          <h1 align="center">
            <p className="effect-underline">
              I'm <span className="mainName">Md. Amir</span>
            </p>
          </h1>
          <h1 align="center">
            <p className="effect-underline">Full Stack Developer</p>
          </h1>
          
        </div>
      </div>
    </GeneralLayout>
  )
}

export default Home
